/**
 * Created by xyf on 2018/8/9.
 */

const API = {
  getCodePicture: '/yy/register/codePicture',
  getVerifyCode: '/yy/register/dxVerifyCode',
  postRegister: '/yy/register/register',
  postLogin: '/yy/login',
  getFocusReply: '/yy/wxbase/getFocusReply',
  postSaveImg: '/yy/baseimg/saveImg',
  getImgList: '/yy/baseimg/list',
  getBandwxInfo: '/yy/wxbase/info',
  postSaveFocusReply: '/yy/wxbase/saveFocusReply',
  getWxKeywordReply: '/yy/wxbase/getWxKeywordReply',
  postSaveWxKeywordReply: '/yy/wxbase/saveWxKeywordReply',
  postRegisterSupply: '/yy/register/registerSupply',
  getWxTw: '/yy/wxbase/getWxTw',
  saveYyWxTw: '/yy/wxbase/saveYyWxTw', //保存图文信息
  saveType: '/yy/basetemplate/saveType',
  getSonType: '/yy/basetemplate/getSonType',
  saveMenu: '/yy/wxbase/saveMenu', //保存菜单
  getAllMenu: '/yy/wxbase/getTreeMenu',
  getClientInfo: '/yy/shop/getBaseInfo', //获取诊所基本信息
  saveClientInfo: '/yy/shop/saveBaseInfo',
  getProductTypeList: '/yy/shop/getProductTypeList',
  saveProductType: '/yy/shop/saveProductType',
  delProductType: id => `/yy/shop/delProductType?id=${id}`,
  getProductList:'/yy/shop/getProductList',
  getKqTypeList:'/yy/shop/getKqTypeList',
  saveProduct:'/yy/shop/saveProduct',
    discountCharge2: '/third/charge',
    getUserCenterMenu: 'yy/front/getCenterMenu',
}

export default API
